<template>
  <div class="row" style="margin-bottom: 12px;">
    <div class="col-md-6">
      <label class="form-label">Parti/liste</label>
      <input
        type="text"
        placeholder="Parti/liste"
        :value="party ? party + ' (' + partyLetter + ')' : partyLetter"
        class="form-control"
        @change="onPartyLetterChanged"
      />
    </div>
    <div class="col-md-4">
      <label class="form-label">Antal stemmer</label>
      <input
        type="text"
        v-mask="'#######'"
        placeholder="Antal stemmer"
        :value="voteCount"
        class="form-control"
        autocomplete="off"
        @change="onVoteCountChanged"
      />
    </div>
    <div class="col-md-2">
      <div class="form-label">&nbsp;</div>
      <button
        title="Fjern rækken"
        tabindex="-1"
        class="btn btn-default"
        @click="$emit('removed', rowId)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path
            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'VoteListItem',
  directives: { mask },
  props: {
    partyLetter: String,
    party: String,
    voteCount: Number,
    rowId: Number,
  },
  emits: ['removed', 'inputchanged'],
  data: function() {
    return {
      partyLetterValue: '',
      voteCountValue: 0,
    };
  },
  methods: {
    onPartyLetterChanged($event) {
      const value = $event.target.value;
      this.partyLetterValue = value;
      this.emitChanges();
    },
    onVoteCountChanged($event) {
      const value = $event.target.value;
      this.voteCountValue = value;
      this.partyLetterValue = this.partyLetter;
      this.emitChanges();
    },
    emitChanges: function() {
      this.$emit('inputchanged', {
        partyLetter: this.partyLetterValue,
        voteCount: this.voteCountValue,
        rowId: this.rowId,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
